// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"vf","title":"vh"};